import { render, staticRenderFns } from "./AgentGroups.vue?vue&type=template&id=2b5f5a29&"
import script from "./AgentGroups.vue?vue&type=script&lang=js&"
export * from "./AgentGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports